import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { themeType } from '../../../common/theme-colors';

export const makeStyles = (colors: themeType) =>
  StyleSheet.create({
    container: {
      height: 44,
      alignItems: 'center',
      flexDirection: 'row',
      borderRadius: theme.radius.small,
      backgroundColor: colors.popupBg,
      ...theme.shadow.strong,
    },
    btnClose: {
      width: 44,
      height: 44,
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      flex: 1,
      marginRight: 44,
      textAlign: 'center',
      fontFamily: theme.fonts.medium,
      color: colors.text,
    },
  });
